import * as server from '../entries/pages/(admin)/admin/home/_page.server.ts.js';

export const index = 5;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(admin)/admin/home/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/(admin)/admin/home/+page.server.ts";
export const imports = ["_app/immutable/nodes/5.-_S87Ctc.js","_app/immutable/chunks/CslV50be.js","_app/immutable/chunks/C3H89rdt.js","_app/immutable/chunks/CuhEQ3BH.js","_app/immutable/chunks/BN8CHBz-.js","_app/immutable/chunks/DFQvIDzh.js","_app/immutable/chunks/Dx3bPppY.js","_app/immutable/chunks/CQrtv1eE.js","_app/immutable/chunks/CWir8Kn7.js","_app/immutable/chunks/sUv9qCDn.js"];
export const stylesheets = ["_app/immutable/assets/Editor.DxLOL-k3.css"];
export const fonts = [];
